import { Col, Popover, Row } from 'antd';
import React, { ReactElement, useState } from 'react';
import PageHeader from '../../../shared/components/pageHeader/PageHeader';
import { authFeatureConstants, GUTTOR_SPACE } from '../../../shared/constants/commonConstants';
import { ReactComponent as ExcelFileIcon } from '../../../assets/images/svg/i_excel_file_icon.svg';
import './ReconciliationTATReport.less';
import UploadFileAlert from '../UploadFileAlert';
import { ReconciliationReportList } from './ReconciliationReportList';
import { canActivate } from '../../../utils/utility';
import ReconciliationDashboard from './ReconciliationDashboard';
import { UploadOutlined, DownloadOutlined } from '@ant-design/icons';
const ReconciliationTATReport = (): ReactElement => {
  const [isAlertModalVisible, setIsAlertModalVisible] = useState(false);
  const [updatedClaimNumbersCount, setUpdatedClaimNumbersCount] = useState(0);
  const [totalClaimCount, setTotalClaimCount] = useState(0);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const editReconciliation = canActivate(authFeatureConstants.EDIT_RECONCILIATION);

  const onButtonClickHandler = (): void => {
    setIsAlertModalVisible(false);
    setIsSuccess(false);
  };

  const successHandler = (
    claimCount: number = 0,
    totalCount: number = 0,
  ): void => {
    setUpdatedClaimNumbersCount(claimCount);
    setTotalClaimCount(totalCount);
    setIsSuccess(true);
  };
  const closeModal = (): void => {
    setIsModalOpen(false);
  };
  const content = (
    <div className="user-dropdown-list">
      <div className="upload" onClick={(e: any): any => setIsModalOpen(true)}><DownloadOutlined />
       <span className="popover-lable">Download Template</span></div>
      <div className="upload" onClick={(): any => setIsAlertModalVisible(true)}><UploadOutlined />
      <span className="popover-lable">Upload Report (.xlsx/csv)</span></div>
    </div>
  );
  const popOverComponent = (): any => {
    return (
      <Popover
        placement="bottom"
        content={content}
        trigger="hover"
      >
        <div>
          <ExcelFileIcon /><span className="popover-heading  mouse-pointer">Update Reconciliation Report</span>
        </div>
      </Popover>
    );
  };
  return (<>
    <div className="reconciliation">
      <PageHeader
        colSize={18}
        offsetClass={true}
        rightComponent={popOverComponent}
      />
      <div className="tab-custom-container">
        <Row gutter={GUTTOR_SPACE}>
          <Col md={16} className="custom-ant-tab">
            {editReconciliation && (
              <>
                {isAlertModalVisible &&
                  <UploadFileAlert
                    isVisible={isAlertModalVisible}
                    onButtonClick={onButtonClickHandler}
                    onSuccess={successHandler}
                    isSuccess={isSuccess}
                    updatedClaimNumbersCount={updatedClaimNumbersCount}
                    totalClaimCount={totalClaimCount}
                  />
                }
              </>
            )}
          </Col>
          <Col md={8}>
            {isModalOpen &&
              <ReconciliationReportList isModalOpen={isModalOpen} closeModal={closeModal} />
            }
          </Col>
        </Row>
      </div>
      <div className="reconciliation-dashboard">
        <ReconciliationDashboard dashboardType="IHX_Finance_Provider_New" />
      </div>
    </div>
    </>
  );
};

export default ReconciliationTATReport;
